import { EmployerCategory } from "@classes/contract/employer-category";
import { WorkerCategory } from "@classes/contract/worker-category";
import { DateTimeFormat } from '@classes/date-time-format';
import { DateTime } from 'luxon';
import { CotisationCode } from "./cotisation-code";

export class CotisationRate {
    cotisationCode: CotisationCode;
    employerCategory: EmployerCategory
    id: number;
    providerCode: string;
    validFrom: string;
    valueRate: number;
    workerCategory: WorkerCategory;

    constructor(
        cotisationCode?: CotisationCode,
        workerCategory?: WorkerCategory,
        employerCategory?: EmployerCategory,
        validFrom?: DateTime,
        valueRate?: number
    ) {
        this.cotisationCode = cotisationCode;
        this.workerCategory = workerCategory;
        this.employerCategory = employerCategory;
        this.validFrom = validFrom?.startOf('month').toFormat(DateTimeFormat.dateTime);
        this.valueRate = valueRate;
    }
    
    static fromObject(object: CotisationRate): CotisationRate {
        return Object.assign(new CotisationRate(), object);
    }
}
